<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		width="48"
		height="48"
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="class"
	>
		<path
			d="M18 36L30 24L18 12"
			stroke="currentColor"
			stroke-width="3"
			stroke-linecap="square"
		/>
	</svg>
</template>
